import _ from 'lodash'
import fp from 'lodash/fp'
import { getCellEventObject } from '@/common/utils/gnb.fp'
import { showBillingPopup } from '@/common/utils/common'
import { resizeThumbnail } from '@/common/utils/image'
import constant from '@/common/resources/constant'
import { parseUrl } from 'query-string'
import { ON_CLICK_CELL, TOAST_TEXT } from '@/common/resources/const'
import cookie from '@/common/utils/cookie'
export default {
  props: {
    cellInfo: {
      type: Object
    },
    thumbnailInfo: {
      type: Object
    }
  },
  methods: {
    goDetail (cellInfo) {
      const { onClick, onNavigation } = fp.flow(fp.get('event_list'), getCellEventObject)(cellInfo)
      this.$events.$emit(ON_CLICK_CELL, onClick)
      const url = _.get(onNavigation, 'url', '')
        .replace(constant.URL_DOMAIN, '')
        .replace(constant.URL_PROTOCOL_DEEP_LINK, '')
        .replace('www.pooq.co.kr', '')
        .replace('www.wavve.com', '')
        .replace('http://', '')
        .replace('https://', '')
      const { query } = parseUrl(url)
      let result = ''
      if (url.indexOf('purchasewebview') > -1) {
        const locationOrign = window.location.protocol + '//' + window.location.hostname
        showBillingPopup({ productId: _.get(query, 'productId', ''),
          productType: 'all',
          returnUrl: constant.URL_PROTOCOL_WITH_DOMAIN,
          canceledUrl: locationOrign + '/callback.html?action=Cancel' })
      } else if (url.indexOf('member.') > -1) {
        window.open('https://' + url, '_blank')
      } else if (url.indexOf('notice_view') > -1) {
        result = url
      } else if (url.indexOf('theme-contents') > -1) {
        const themeId = _.get(query, 'themeid', '')
        result = `/list/EN${themeId}`
      } else if (url === '/voucher/index.html') {
        result = '/voucher/index'
      } else if (url === '/voucher/recommend.html') {
        result = '/voucher/recommend'
      } else {
        result = url.replace('/index.html', '').replace('.html', '')
      }
      if (result.indexOf('/player/vod') > -1 && result.indexOf('page') === -1) {
        result += '&page=1'
      }
      this.beforeRouterToDetail({
        onNavigation,
        fn: () => this.$router.push(result)
      })
    },
    beforeRouterToDetail ({ onNavigation, fn }) {
      const toastText = _.get(onNavigation, TOAST_TEXT, '')
      if (toastText !== '') {
        this.$events.$emit('OPEN_PPV_TOAST', fn, toastText)
      } else {
        fn()
      }
    },
    getLazyLoadingImageObject () {
      let thumbnail = _.get(this.cellInfo, 'thumbnail', '')
      if (thumbnail === '') {
        thumbnail = this.thumbnailInfo.placeholderImage
      }
      return {
        src: resizeThumbnail(thumbnail, { width: this.thumbnailInfo.width, height: this.thumbnailInfo.height, isSquare: this.thumbnailInfo.isSquare }),
        error: this.thumbnailInfo.placeholderImage,
        loading: this.thumbnailInfo.placeholderImage
      }
    }
  },
  computed: {
    cellTagList () {
      return this.topTagList.concat(this.bottomTagList)
    },
    topTagList () {
      return _.get(this.cellInfo, 'top_taglist', [])
    },
    bottomTagList () {
      return _.get(this.cellInfo, 'bottom_taglist', [])
    },
    hasBottomTagList () {
      return this.bottomTagList.length > 0
    },
    ageTag () {
      return _.get(this.cellInfo, 'age_tag', '')
    },
    adultDimClass () {
      const eventListUrl = _.get(this.cellInfo, 'event_list.1.url', '')
      this.type = eventListUrl.indexOf('player/movie') > -1 ? 'movie' : 'vod'
      const isDim = (!cookie.hasCredential() || cookie.isNotVerifiedAdultUser()) && _.get(this.cellInfo, 'age', 0) >= 21
      if (isDim) {
        return this.type === 'vod' ? 'vod-lock-21' : 'movie-lock-21'
      } else {
        return ''
      }
    },
    targetAge () {
      return Number(_.get(this.cellInfo, 'age', 0))
    },
    isAdultContent () {
      return this.targetAge > 20
    },
    progress () {
      return _.get(this.cellInfo, 'progress', '')
    },
    hasProgress () {
      return this.progress !== ''
    },
    rank () {
      return _.get(this.cellInfo, 'rank', '')
    },
    hasRank () {
      return this.rank !== ''
    },
    titleList () {
      return _.get(this.cellInfo, 'title_list', [])
    }
    // getLazyLoadContainerOption () {
    //   return {
    //     selector: 'img',
    //     loading: this.thumbnailInfo.placeholderImage,
    //     error: this.thumbnailInfo.placeholderImage
    //   }
    // }
  }
}
